<template>
  <div class="enroll-error">
    <div>
      <div>
        Sorry, you're not able to enroll in this study because our records show you already
        participated in this study or a related one. If you'd like to be notified about future study
        opportunities join <a href="https://morebetter.ltd/join-study">our study registry</a>.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnrollError',
};
</script>

<style lang="scss" scoped>
@import '../styles/_variables.scss';

.enroll-error {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
}

@media (min-width: $breakpoint-tablet) {
  .complete {
    justify-content: flex-start;
  }
}
</style>
